/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockAdjustResVo
 */
export interface AdminStockAdjustResVo {
    /**
     * SKU主键ID
     * @type {number}
     * @memberof AdminStockAdjustResVo
     */
    skuId?: number;
    /**
     * 商品批次 goodsId
     * @type {number}
     * @memberof AdminStockAdjustResVo
     */
    goodsId?: number;
    /**
     * 调整方向：1 增加 2 减少
     * @type {number}
     * @memberof AdminStockAdjustResVo
     */
    direction?: number;
    /**
     * 本次调整数量
     * @type {number}
     * @memberof AdminStockAdjustResVo
     */
    adjustedQty?: number;
    /**
     * 调整后批次可用库存
     * @type {number}
     * @memberof AdminStockAdjustResVo
     */
    batchAvailableQty?: number;
    /**
     * 调整后该货位可用数量
     * @type {number}
     * @memberof AdminStockAdjustResVo
     */
    locationAvailableQty?: number;
}

/**
 * Check if a given object implements the AdminStockAdjustResVo interface.
 */
export function instanceOfAdminStockAdjustResVo(value: object): value is AdminStockAdjustResVo {
    return true;
}

export function AdminStockAdjustResVoFromJSON(json: any): AdminStockAdjustResVo {
    return AdminStockAdjustResVoFromJSONTyped(json, false);
}

export function AdminStockAdjustResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'goodsId': json['goodsId'] == null ? undefined : json['goodsId'],
        'direction': json['direction'] == null ? undefined : json['direction'],
        'adjustedQty': json['adjustedQty'] == null ? undefined : json['adjustedQty'],
        'batchAvailableQty': json['batchAvailableQty'] == null ? undefined : json['batchAvailableQty'],
        'locationAvailableQty': json['locationAvailableQty'] == null ? undefined : json['locationAvailableQty'],
    };
}

export function AdminStockAdjustResVoToJSON(json: any): AdminStockAdjustResVo {
    return AdminStockAdjustResVoToJSONTyped(json, false);
}

export function AdminStockAdjustResVoToJSONTyped(value?: AdminStockAdjustResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuId': value['skuId'],
        'goodsId': value['goodsId'],
        'direction': value['direction'],
        'adjustedQty': value['adjustedQty'],
        'batchAvailableQty': value['batchAvailableQty'],
        'locationAvailableQty': value['locationAvailableQty'],
    };
}

